<template>
  <div class="xl:w-full xl:h-full flex xl:flex-nowrap flex-wrap">
    <div
      class="xl:w-2/3 sm:items-start items-center sm:text-left text-center w-full xl:h-full xl:pt-14 pt-6 xl:px-14 lg:px-20 sm:px-14 px-5 text-gray-700 text-base"
    >
      <h1 class="my-10">Existing Integrations</h1>
      <p>Merchants can connect with Banyan through their pre-existing integrations with financial transaction companies, such as Square and Clover. This process is entirely self-service, and should take roughly 15 minutes.</p>

      <h2>Getting Started</h2>
      <ul class="list-decimal	 text-left overflow-auto pl-10 mb-4">
        <li class="mb-3">Fill out this [form] <a href="https://merchant.marketing.getbanyan.com" target="_blank">(https://merchant.marketing.getbanyan.com)</a> to share your basic information such as name, email and address. It will automatically create a Banyan merchant account for you, and email you the credentials.</li>
        <li class="mb-3">Navigate to the merchant portal, and log in with your new credentials.</li>
        <li class="mb-3">The homepage should show a selection of different services that we support. Select the service you would like to integrate, and the page will redirect you to a login window for that account. Login to connect with Banyan.</li>
        <li class="mb-3">Depending on the service, you may be redirected to a list of locations under your account name. For each location you’d like to integrate, click it to go to the ‘connect’ page for Banyan.</li>
        <li class="mb-3">Next, a window will prompt you to Connect with Banyan. Hit ‘Connect’ then ‘Accept,’ and then you will be redirected to our website. Once there, wait for a success message. After that, you’re all set up.</li>
      </ul>
      <h2>Quick Links</h2>
      <p class="flex flex-col lg:items-start items-center">
        <a href="https://merchant.dashboard.getbanyan.com">
          <img :src="require('@/assets/images/square.png')" class="lg:mt-0 sm:mt-2 mt-8 object-contain md:object-scale-down w-28 h-28" />
        </a>
        <br />
        <a href="https://merchant.dashboard.getbanyan.com">
          <img :src="require('@/assets/images/clover.png')" class="lg:mt-0 sm:mt-2 mt-8 object-contain md:object-scale-down w-28 h-28" />
        </a>
      </p>
    </div>

    <div class="xl:w-1/3 xl:block hidden w-full xl:self-stretch pt-20 px-6 relative"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("common", ["isOffset"]),
  },
  methods: {
    scrollToElement(el) {
      document.querySelector(el).scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
}
</script>